import DefaultMainPage from "../../../pages/DefaultMainPage";
import SeasonThemeManager from "./SeasonThemeManager";
import SeasonThemeTable from "./SeasonThemeTable";

const seasonThemeMasterMenuItems = [
    {path: "/seasonThemeMaster", component: <SeasonThemeManager/>, label: '시즌 테마'},
    {path: "/seasonThemeMaster/table", component: <SeasonThemeTable/>, label: '시즌 테마 테이블'},
];

export const seasonThemeMasterRoutes = {
    path: "/seasonThemeMaster",
    component: <DefaultMainPage buttons={seasonThemeMasterMenuItems}/>,
    children: seasonThemeMasterMenuItems
}